import React from 'react';
import PropTypes from 'prop-types';
import {IntroSection, GamePlaySection, RecruitHeroes, DiscoverKingdom, MasterElements, HundredsHeroes} from '../../components/home';
import {connectToStores} from 'epic-alt-utils/index';
import {HomeStore, LoginStore, AppConfigStore, HeaderStore} from '../../stores';
import {onDownload, downloadIOS, goToAndroidFlow} from '../../utils/Utils';
import {localizedMessage} from '../../components/message/Message';


@connectToStores
export default class HomeView extends React.PureComponent {
    static propTypes = {
        history: PropTypes.object,
        homeStore: PropTypes.object,
        headerStore: PropTypes.object,
        appConfigStore: PropTypes.object,
        loginStore: PropTypes.object,
        subscriptionStore: PropTypes.object
    };

    static getStores() {
        return [HomeStore, LoginStore, AppConfigStore, HeaderStore];
    }

    static getPropsFromStores() {
        return {
            homeStore: HomeStore.getState(),
            headerStore: HeaderStore.getState(),
            loginStore: LoginStore.getState(),
            appConfigStore: AppConfigStore.getState()
        };
    }

    getDownloadContainer = () => {
        const {appConfigStore = {}, headerStore, history} = this.props;
        const bowser = headerStore.bowser();
        const {
            header
        } = this.props.homeStore;
        if (!header) return null;
        const isKorea = appConfigStore.country === 'KR';
        const isGameLaunched = appConfigStore.isGameLaunched;
        const {downloadTxt, comingSoon, pcDownloadNote, iosDownloadNote, androidDownloadNote, pcSubNote} = header;
        const btnText = isGameLaunched ? downloadTxt : comingSoon;
        let downloadNote = pcDownloadNote;

        if (bowser.android) {
            downloadNote = androidDownloadNote;
        } else if (bowser.ios) {
            downloadNote = iosDownloadNote;
        }

        // korean ip doesn't allow to download PC version
        if (isKorea) {
            return (
                <div className="download-container">
                    {
                        isGameLaunched ?
                            <>
                                <button onClick={() => downloadIOS(appConfigStore.iOSDownloadUrl)} className="btn-download font_0">
                                    {localizedMessage('epic.common.ios')}
                                </button>
                                <button onClick={() => goToAndroidFlow(history)} className="btn-download font_0">
                                    {localizedMessage('epic.common.android')}
                                </button>
                            </> :
                            <button className="btn-download font_0" disabled>
                                {btnText}
                            </button>
                    }
                </div>
            )
        }

        return (
            <div className="download-container">
                    <button className="btn-download font_0" onClick={() => onDownload(appConfigStore, headerStore, history)} disabled={!isGameLaunched}>
                        {btnText}
                    </button>
                    {isGameLaunched && (
                        <div className="download-note">
                            <span>{downloadNote}</span>
                            {!bowser.android && !bowser.ios && (
                                <div>{pcSubNote}</div>
                            )}
                        </div>
                    )}
            </div>
        )
    }

    render() {
        const {
            about, discover, elements, gameplay, stronghold
        } = this.props.homeStore;
        const {appConfigStore} = this.props;
        const isKorea = appConfigStore.country === 'KR';
        const buttonContainer = this.getDownloadContainer();
        return (
            <div className="new-bb-home">
                <IntroSection
                    isKorea={isKorea}
                    buttonContainer={buttonContainer}
                    />
                <GamePlaySection content={gameplay} />
                <RecruitHeroes content={about} />
                <DiscoverKingdom content={discover} />
                <MasterElements content={elements} />
                <HundredsHeroes
                    content={stronghold}
                    buttonContainer={buttonContainer}
                    isKorea={isKorea} />
            </div>
        );
    }
}

